import { createSlice } from '@reduxjs/toolkit';

// Store callbacks outside Redux — avoids serialization issues
let _confirmAction = null;
let _cancelAction = null;

export const setDialogCallbacks = ({ confirmAction, cancelAction }) => {
  _confirmAction = confirmAction;
  _cancelAction = cancelAction;
};

export const getDialogCallbacks = () => ({
  cancelAction: _cancelAction,
  confirmAction: _confirmAction,
});

export const clearDialogCallbacks = () => {
  _confirmAction = null;
  _cancelAction = null;
};

const initialState = {
  header: '',
  leftButtonActionType: 'cancel',
  leftButtonText: 'Back',
  message: '',
  open: false,
  params: {},
  rightButtonActionType: 'confirm',
  rightButtonText: 'Confirm',
  warningList: null,
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'confirmationDialog',
  reducers: {
    closeConfirmationDialog() {
      return initialState;
    },
    openConfirmationDialog(state, { payload }) {
      return {
        ...state,
        header: payload.header || '',
        leftButtonActionType: payload.leftButtonActionType || initialState.leftButtonActionType,
        leftButtonText: payload.leftButtonText || initialState.leftButtonText,
        message: payload.message || '',
        open: true,
        params: payload.params || {},
        rightButtonActionType: payload.rightButtonActionType || initialState.rightButtonActionType,
        rightButtonText: payload.rightButtonText || initialState.rightButtonText,
        warningList: payload.warningList || null,
      };
    },
  },
});

export const { openConfirmationDialog: _openDialog, closeConfirmationDialog } = actions;

// Wrapper that stores callbacks outside Redux, then dispatches serializable data
export const openConfirmationDialog = payload => dispatch => {
  setDialogCallbacks({
    cancelAction: payload.cancelAction,
    confirmAction: payload.confirmAction,
  });
  dispatch(
    _openDialog({
      header: payload.header,
      leftButtonActionType: payload.leftButtonActionType,
      leftButtonText: payload.leftButtonText,
      message: payload.message,
      params: payload.params,
      rightButtonActionType: payload.rightButtonActionType,
      rightButtonText: payload.rightButtonText,
      warningList: payload.warningList,
    })
  );
};

export const getConfirmationDialog = state => state.confirmationDialog;

export default reducer;
